export default "__VITE_ASSET__5b985bea__"